import {
  createRedoReturnDetailsRpcClient,
  RedoReturnDetailsRpcClient,
} from "@redotech/redo-merchant-return-details-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoReturnDetailsRpcClientContext: Context<
  RedoReturnDetailsRpcClient | undefined
> = createContext<RedoReturnDetailsRpcClient | undefined>(undefined);
RedoReturnDetailsRpcClientContext.displayName =
  "RedoReturnDetailsRpcClientContext";

export function RedoReturnDetailsRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const client = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoReturnDetailsRpcClient({
      baseURL: new URL(`${baseUrl}/return-details-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoReturnDetailsRpcClientContext.Provider value={client}>
      {children}
    </RedoReturnDetailsRpcClientContext.Provider>
  );
}
